import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgFor } from '@angular/common';
import { RevealOnScrollDirective } from '../../reveal-on-scroll.directive';
import { AboutSectionService } from './about-section.service';

@Component({
  selector: 'app-about-section',
  standalone: true,
  imports: [NgFor, RevealOnScrollDirective],
  templateUrl: './about-section.component.html',
  styleUrl: './about-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutSectionComponent {
  get content() {
    return this.aboutService.content;
  }

  constructor(private readonly aboutService: AboutSectionService) {}
}
